import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=43670df2&"
import script from "./FileSelector.vue?vue&type=script&lang=ts&"
export * from "./FileSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports